import React from 'react';

import Config from '@skin_config';
import Timer from '@common/components/timer';
import Loader from '@common/components/loader';
import { useTranslation } from '@common/hooks/translation';

const VerificationLoading = ({ closePopup }) => {
  const t = useTranslation();

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('Verification')}</h3>
      <div className="popup-main-content">
        <p className="text-center">{t('please wait while we are checking your ID card details')}</p>
        <div className="spinner-wrapper">
          <Loader />
        </div>
      </div>
      <Timer onFinish={closePopup} duration={Config.main.cashoutPopupTimer} />
    </div>
  );
};

export default VerificationLoading;
